// extracted by mini-css-extract-plugin
export default {"icon-square":"LineIcon_icon-square__PJ2QS","icon-line":"LineIcon_icon-line__fDdhr","icon-circle":"LineIcon_icon-circle__lfcVF","icon-gusty_line":"LineIcon_icon-gusty_line__q3aCV"};